import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import {
    Route, Package, MessageCircle, DollarSign,
    Search, Gift, Boxes, CheckCircle, ArrowRight,
} from '../../icons';

const TRAVELER_STEPS = [
    { Icon: Route,          title: 'Publiez votre trajet',           text: "Indiquez votre destination, la date de départ et le volume de colis que vous pouvez transporter. Gratuit, rapide, en 2 minutes." },
    { Icon: MessageCircle,  title: 'Les expéditeurs vous contactent', text: "Recevez des demandes dans votre messagerie. Discutez du tarif, de la date et du lieu de remise. Vous choisissez librement." },
    { Icon: DollarSign,     title: 'Récupérez votre paiement',        text: "Après la livraison, le destinataire récupère le colis et vous règle le montant convenu en main propre." },
];

const SENDER_STEPS = [
    { Icon: Package,        title: "Publiez votre annonce d'envoi",  text: "Décrivez votre colis, précisez la destination et proposez un tarif. Plus c'est détaillé, plus vite vous trouvez un voyageur." },
    { Icon: Search,         title: 'Trouvez le bon voyageur',         text: "Parcourez les trajets disponibles ou attendez qu'un voyageur vous contacte. Consultez son profil et ses avis avant de vous décider." },
    { Icon: Gift,           title: 'Préparez votre colis',            text: "Emballez soigneusement, étiquetez clairement et respectez les restrictions douanières du pays de destination." },
    { Icon: CheckCircle,    title: 'Confirmez la livraison',          text: "Une fois la remise faite, restez en contact avec le voyageur. Confirmez la réception et laissez un avis honnête." },
];

function StepCard({ step: { Icon, title, text }, number }) {
    return (
        <div className="col-12 col-sm-6 col-lg-3 mb-4">
            <div className="how-card">
                <div className="how-number">{number}</div>
                <div style={{ marginBottom: 14 }}>
                    <Icon size={26} strokeWidth={1.6} color="var(--primary)" />
                </div>
                <h4 className="how-title">{title}</h4>
                <p className="how-text">{text}</p>
            </div>
        </div>
    );
}

function HowItWorks() {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div>
            <div className="page-hero">
                <div className="container">
                    <p className="page-hero__eyebrow">Guide</p>
                    <h1 className="page-hero__title">Simple comme bonjour !</h1>
                    <p className="page-hero__subtitle">
                        Que vous soyez voyageur ou expéditeur, eudeliv vous accompagne étape par étape pour un transport de colis sans prise de tête.
                    </p>
                </div>
            </div>

            <section className="section-padding">
                <div className="container">
                    <div className="mb-5">
                        <span className="role-badge"><Route size={14} strokeWidth={2} /> Vous voyagez</span>
                        <h2 className="section-title">Rentabilisez votre trajet</h2>
                        <p className="section-subtitle" style={{ textAlign: 'left', maxWidth: 520 }}>
                            Vous avez de la place dans vos bagages ? Transportez des colis et couvrez vos frais de voyage.
                        </p>
                    </div>
                    <div className="row">
                        {TRAVELER_STEPS.map((s, i) => <StepCard key={i} step={s} number={i + 1} />)}
                    </div>
                    <Link to="/addtrip">
                        <Button color="primary" style={{ borderRadius: 50, padding: '13px 28px', fontWeight: 700 }}>
                            Proposer un trajet
                        </Button>
                    </Link>
                </div>
            </section>

            <section className="section-padding bg-light-gray">
                <div className="container">
                    <div className="mb-5">
                        <span className="role-badge"><Package size={14} strokeWidth={2} /> Vous envoyez</span>
                        <h2 className="section-title">Envoyez à petit prix</h2>
                        <p className="section-subtitle" style={{ textAlign: 'left', maxWidth: 520 }}>
                            Profitez du réseau eudeliv pour expédier vos colis jusqu'à 70 % moins cher que les transporteurs classiques.
                        </p>
                    </div>
                    <div className="row">
                        {SENDER_STEPS.map((s, i) => <StepCard key={i} step={s} number={i + 1} />)}
                    </div>
                    <Link to="/adddelivery">
                        <Button color="primary" style={{ borderRadius: 50, padding: '13px 28px', fontWeight: 700 }}>
                            Envoyer un colis
                        </Button>
                    </Link>
                </div>
            </section>

            <section className="cta-section">
                <div className="container">
                    <h2 className="cta-title">Prêt à vous lancer ?</h2>
                    <p className="cta-subtitle">
                        Rejoignez des milliers d'utilisateurs qui font confiance à eudeliv pour leurs envois internationaux.
                    </p>
                    <div className="cta-buttons">
                        <Link to="/register">
                            <Button color="primary" size="lg" className="cta-btn">Créer un compte gratuit</Button>
                        </Link>
                        <Link to="/searchannouncements">
                            <Button outline color="light" size="lg" className="cta-btn">Voir les annonces</Button>
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default HowItWorks;
